import { useCallback, useEffect } from 'react';
import noop from 'lodash/noop';

import { I13N_TYPE_PAGE_VIEW } from 'Lib/constants/i13nSpec';

const useInstrumentation = ({
  executeEvent = noop,
  path,
}: {
  executeEvent: (eventName: string, values?: Record<string, any>) => void;
  path?: string | undefined;
}) => {
  const sendPageView = useCallback(
    (page: string) => {
      executeEvent(I13N_TYPE_PAGE_VIEW, { page });
    },
    [executeEvent]
  );

  useEffect(() => {
    if (path) {
      sendPageView(path);
    }
  }, [path, sendPageView]);
};

export default useInstrumentation;
